<template>
  <div>
    <form class="form-inline vp-mt-30" v-if="password != playgroundPassword">
      <div class="form-group vp-width-400 text-center m-auto">
        <label class="mr-5">Password</label>
        <input type="password" v-model="password" class="form-control" />
      </div>
    </form>

    <!-- Show playground if password matches -->
    <template v-if="password == playgroundPassword">
      <div class="vp-bg-black-2 d-block playground-container">
        <!-- start::Multiselect -->
        <template>
          <h2
            class="vp-font-weight-700 vp-pt-20 vp-ml-20"
            style="cursor: pointer"
            @click="toggleComponent('multiselect')"
          >
            VpMultiselect
          </h2>
          <div v-show="showMultiSelect">
            <multiselect-demo />
          </div>
        </template>
        <!-- end::Multiselect -->

        <!-- start::Treeselect -->
        <template>
          <h2
            class="vp-font-weight-700 vp-pt-20 vp-ml-20"
            style="cursor: pointer"
            @click="toggleComponent('treeselect')"
          >
            VpTreeselect
          </h2>
          <div v-show="showTreeselect">
            <treeselect-demo />
          </div>
        </template>
        <!-- end::Treeselect -->

        <!-- start::Input -->
        <template>
          <h2
            class="vp-font-weight-700 vp-pt-20 vp-ml-20"
            style="cursor: pointer"
            @click="toggleComponent('input')"
          >
            VpInput
          </h2>
          <div v-show="showInput">
            <input-demo />
          </div>
        </template>
        <!-- end::Input -->

        <!-- start::Radio -->
        <template>
          <h2
            class="vp-font-weight-700 vp-pt-20 vp-ml-20"
            style="cursor: pointer"
          >
            VpRadio
          </h2>
          <div>
            <v-radio-group v-model="selectedColor">
              <v-radio label="Red" value="red"></v-radio>
              <v-radio label="Blue" value="blue"></v-radio>
              <v-radio label="Green" value="green"></v-radio>
            </v-radio-group>
          </div>
        </template>
        <!-- end::Radio -->

        <!-- start::Editor -->
        <template>
          <h2
            class="vp-font-weight-700 vp-pt-20 vp-ml-20"
            style="cursor: pointer"
            @click="toggleComponent('editor')"
          >
            VpEditor
          </h2>
          <div v-show="showEditor">
            <editor-demo />
          </div>
        </template>
        <!-- end::Editor -->

        <!--  Locale test-->
        <template>
          <h2
            class="vp-font-weight-700 vp-pt-20 vp-ml-20"
            style="cursor: pointer"
            @click="toggleComponent('locale')"
          >
            Locale
          </h2>
          <div v-show="showLocale">
            <LocaleDemo />
          </div>
        </template>
        <!-- Locale test -->
      </div>
    </template>
  </div>
</template>

<script>
import MultiselectDemo from "./MultiselectDemo.vue";
import TreeselectDemo from "./TreeselectDemo.vue";
import InputDemo from "./InputDemo.vue";
import EditorDemo from "./EditorDemo.vue";
import LocaleDemo from "./LocaleDemo.vue";

export default {
  data() {
    return {
      showMultiSelect: false,
      showTreeselect: false,
      showInput: false,
      showEditor: false,
      showLocale: false,
      password: "",
      playgroundPassword: "00000",
      selectedColor: "red",
    };
  },
  components: {
    MultiselectDemo,
    TreeselectDemo,
    InputDemo,
    EditorDemo,
    LocaleDemo,
  },
  methods: {
    toggleComponent(component) {
      switch (component) {
        case "multiselect":
          this.showMultiSelect = !this.showMultiSelect;
          break;
        case "treeselect":
          this.showTreeselect = !this.showTreeselect;
          break;
        case "input":
          this.showInput = !this.showInput;
          break;
        case "editor":
          this.showEditor = !this.showEditor;
          break;
        case "locale":
          this.showLocale = !this.showLocale;
          break;
      }
    },
  },
};
</script>

<style scoped>
.playground-container {
  height: 100vh;
  height: fit-content;
}
</style>
